export default __webpack_public_path__ + "static/media/landing_map.634df0dc.jpg";